module.exports = __webpack_public_path__ + "a96e3c5ef8a3a982f7f7201f96f90c2f.png";